<script>
    import { GET, POST } from "../../components/communication.js";
    import { authToken, sessionStorageSet, sessionStorageRemove, flashErrorMessage, flashSuccessMessage }
        from "../../components/stores.js";
    import { navigate } from "svelte-routing";

    let passwordForm = { email: ""};
    async function handleSubmit(event) {
        sessionStorageRemove("authToken");
        authToken.set('');

        const response = POST("/C/forgotPassword", JSON.stringify(passwordForm));
        const data = await response;
        console.log("Response: ", response);
        if(data && data.error === undefined) {
            navigate('/kirjaudu', { replace: false });
            flashSuccessMessage.set("Uusi salasana on lähetetty antamaasi osoitteeseen.");
        } else {
            alert("Virhe");
            flashErrorMessage.set("Salasanan lähettämisessä ongelmia. Ole yhteydessä Dynamosaliin suoraan.");
        }

    }
</script>

<div class="page row">
    <div class="col-sm-12 col-md-6 col-lg-6" style="margin-left:auto;margin-right:auto;">
        <div class="card">
            <h5 class="card-header">Jos olet unohtanut tai haluat vaihtaa salasanan</h5>
            <div class="card-body">
                <form on:submit|preventDefault={handleSubmit}>
                    <div class="form-group">
                        <label for="email">Sähköposti</label>
                        <input class="form-control"
                                required
                                type="email"
                                id="email"
                                bind:value={passwordForm.email} />
                    </div>
                    <button type="submit" class="btn btn-primary">Lähetä salasana</button>
                </form>
            </div>
        </div>
    </div>
</div>
